import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./features/auth/loginSlice";
import signupReducer from "./features/auth/signupSlice";
import customerReducer from "./features/customer/customerSlice";
import locationReducer from "./features/mapSlice";
import userReducer from "./features/userApiSlice";
import propertyReducer from "./features/property/propertySlice";
import dashboardReducer from "./features/dashBoard/dashBoardSlice";
import commonReducer from "./features/common/commonSlice";
import { jaagaGptSlice } from "./features/jaagaGpt/jaagaGptSlice";
import legalServiceReducer from "./features/legal/legalServiceSlice";
import navbarReducer from "./features/navbar/navbarSlice";
import servicesReducer from "./features/services/servicesSlice";
import documentServiceSlice from "./features/documentService/documentServiceSlice";
import { statesApiService } from "./features/statesQuery";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import statesReducer from "./features/stateSlice";
import { authApiService } from "./features/auth/authService";
import { userApiService } from "./features/userQuery";
import { b2bApiService } from "./features/b2bQuery";
import { couponApiService } from "./features/couponQuery";

import { propertyApiService } from "./features/propertyQuery";
import { servicesService } from "./features/servicesQuery";
import modalReducer from "./features/modalSlice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    signup: signupReducer,
    customer: customerReducer,
    locations: locationReducer,
    property: propertyReducer,
    commonSlice: commonReducer,
    dashBoard: dashboardReducer,
    [jaagaGptSlice.reducerPath]: jaagaGptSlice.reducer,
    legal: legalServiceReducer,
    navbar: navbarReducer,
    modal: modalReducer,
    services: servicesReducer,
    documentService: documentServiceSlice,
    [statesApiService.reducerPath]: statesApiService.reducer,
    [userApiService.reducerPath]: userApiService.reducer,
    [b2bApiService.reducerPath]: b2bApiService.reducer,
    [servicesService.reducerPath]: servicesService.reducer,
    [authApiService.reducerPath]: authApiService.reducer,
    [couponApiService.reducerPath]: couponApiService.reducer,
    [propertyApiService.reducerPath]: propertyApiService.reducer,
    states: statesReducer,
    users: userReducer,
  },
  middleware: (gDM) =>
    gDM().concat(
      jaagaGptSlice.middleware,
      authApiService.middleware,
      propertyApiService.middleware,
      userApiService.middleware,
      b2bApiService.middleware,
      servicesService.middleware,
      statesApiService.middleware,
      couponApiService.middleware,
    ),
});

setupListeners(store.dispatch);
